import { TextField } from '@mui/material';
import moment from 'moment';
import React, { FC, useState } from 'react';

import { TDataSet } from '../types';

type TRemoveVisit = {
  dataset: TDataSet;
  isDisabled: boolean;
  setIsDisabled: (value: boolean) => void;
  removeModal: () => void;
};

const convertDate = (date: moment.MomentInput) => moment(date).format('LL'); // TODO: later move to utils.ts
const MAX_LENGTH = 100;

const RemoveVisit: FC<TRemoveVisit> = ({ dataset, isDisabled, setIsDisabled, removeModal }: TRemoveVisit) => {
  const { isBulk, isReportConfirmed } = dataset;
  const [inputText, useInputText] = useState('');

  return (
    <div className='remove-visit'>
      <h2 className='remove-visit__title'>{isBulk ? '⚠ この受診者情報と受診歴を削除しますか？' : '⚠ この受診歴を削除しますか？'}</h2>
      <ul className='remove-visit__list'>
        <li className='remove-visit__item'>
          <span>院内ID:</span>
          <span>{dataset.hospitalPatientId}</span>
        </li>
        <li className='remove-visit__item'>
          <span>受診者名:</span>
          <span>{dataset.name?.replace('()', '')}</span>
        </li>
        <li className='remove-visit__item'>
          <span>生年月日:</span>
          <span>{convertDate(dataset.birthDate)}</span>
        </li>
        <li className='remove-visit__item'>
          <span>受診歴:</span>
          <span>{isBulk ? 'すべての受診歴' : convertDate(dataset.registrationDate)}</span>
        </li>
      </ul>
      {isReportConfirmed ? (
        <div className='remove-visit__input-wrapper'>
          {isBulk ? (
            <p className='remove-visit__warning'>
              <u>受診歴には確定済みの情報が含まれます。</u>
              <br />
              また、一度削除すると、復元はできません。本当に実行しますか？
            </p>
          ) : (
            <p className='remove-visit__warning'>
              <u>この受診歴には確定済みの情報が含まれます。</u>
              <br />
              また、一度削除すると、復元はできません。本当に実行しますか？
            </p>
          )}
          <span className='remove-visit__input-text'>
            削除理由<i>＊</i>
          </span>
          <TextField
            sx={{
              borderRadius: '15px',
              '& .MuiInputBase-root': {
                borderRadius: '15px',
              },
            }}
            placeholder='削除理由を入力してください'
            fullWidth
            multiline
            minRows={5}
            maxRows={5}
            variant='outlined'
            value={inputText}
            onInput={(evt) => {
              const target = evt.target as HTMLInputElement;
              const value = target.value;
              if (value.replace(/\s/g, '').length > MAX_LENGTH) return;
              // eslint-disable-next-line react-hooks/rules-of-hooks
              useInputText(target.value);
            }}
            onPaste={(evt) => {
              evt.preventDefault();
              const { clipboardData } = evt;
              if (clipboardData) {
                const pastedText = clipboardData.getData('text/plain');
                if (pastedText && (inputText + pastedText).length <= MAX_LENGTH) {
                  // eslint-disable-next-line react-hooks/rules-of-hooks
                  useInputText(inputText + pastedText);
                }
              }
            }}
          />
          <span className='remove-visit__input-note'>
            {inputText.replace(/\s/g, '').length}/{MAX_LENGTH}文字
          </span>
        </div>
      ) : null}
      <div className='remove-visit__btn-wrapper'>
        <button className='remove-visit__btn btn btn--additional' type='button' onClick={removeModal} disabled={isDisabled}>
          キャンセル
        </button>
        <button
          className={`remove-visit__btn btn btn--main ${isDisabled ? 'btn--loading' : ''}`}
          type='submit'
          onClick={() => {
            if (dataset.onAccept) dataset.onAccept(removeModal, setIsDisabled, inputText.trim());
          }}
          disabled={isDisabled || (isReportConfirmed ? !inputText.replace(/\s/g, '').length : undefined)}
        >
          削除する
        </button>
      </div>
    </div>
  );
};

export default RemoveVisit;
